import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';
import { ModalPanel } from '@els/els-react--modal-panel';
import AppStorage from '@Services/AppStorage';
import bannerBackground1280 from '@assets/avif/Banner-background-QS-1280.avif';
import bannerBackground1920 from '@assets/avif/Banner-background-QS-1920.avif';
import bannerBackground2560 from '@assets/avif/Banner-background-QS-2560.avif';
import { QUICK_SEARCH_TRACKING_BUTTON_TYPES, trackQuickSearchButtonClick } from '../analytics';
import SearchTipsModalContent from '../SearchTips/SearchTipsModalContent/SearchTipsModalContent';

import './BuildQueryHeading.scss';

const QUICK_SEARCH_HEADING = 'Explore chemistry with Reaxys';
const bannerBackgroundSrcSet = `${bannerBackground1280} 1280w, ${bannerBackground1920} 1920w, ${bannerBackground2560} 2560w`;

function BuildQueryHeading({ isAIQuickSearchBannerDisabled, updateInputText, onExampleApplied }) {
  const [showSearchTips, setShowSearchTips] = useState(false);

  const handleExampleClick = (exampleText) => {
    updateInputText(exampleText);
    onExampleApplied();
    setShowSearchTips(false);
    AppStorage.instance.setToSessionStorage('quickSearchExampleUsed', exampleText);
  };

  return (
    <div className={`build-query-heading ${isAIQuickSearchBannerDisabled ? 'build-query-heading--banner-disabled' : ''}`}>
      <div className="build-query-heading__content">
        {isAIQuickSearchBannerDisabled ? (
          <h1 className="build-query-heading__title u-els-font-family-serif">{QUICK_SEARCH_HEADING}</h1>
        ) : (
          <div className="build-query-heading__banner-wrapper">
            <picture className="build-query-heading__banner-picture">
              <img
                src={bannerBackground1280}
                srcSet={bannerBackgroundSrcSet}
                sizes="100vw"
                alt=""
                aria-hidden="true"
                className="build-query-heading__banner-image"
                decoding="async"
                loading="eager"
              />
            </picture>
            <div className="build-query-heading__banner-copy">
              <h1 className="build-query-heading__banner-title u-els-font-family-serif">
                AI search, <span className="u-els-font-family-serif-italic">not just</span> keyword search
              </h1>
              <p className="build-query-heading__banner-description u-els-font-size-h3 u-els-margin-bottom u-els-line-height-heading">
                Our new text search is built specifically for you. We didn&apos;t just plug in a generic AI solution.
              </p>
              <ButtonWithIcon
                type="link"
                sprite="ChevronRight"
                iconRight
                data-e2e="banner-search-tips-button"
                className="build-query-heading__learn-more u-els-font-size-h3"
                onClick={() => {
                  trackQuickSearchButtonClick(QUICK_SEARCH_TRACKING_BUTTON_TYPES.learnHowItWorks);
                  setShowSearchTips(!showSearchTips);
                }}>
                Learn how it works
              </ButtonWithIcon>
            </div>
          </div>
        )}
      </div>
      {showSearchTips && (
        <ModalPanel
          className="c-els-modal--panel-custom"
          panelPosition="right"
          modalProps={{
            onClose: () => {
              setShowSearchTips(false);
            },
            label: 'Learn how it works',
          }}>
          <SearchTipsModalContent onExampleClick={handleExampleClick} />
        </ModalPanel>
      )}
    </div>
  );
}

BuildQueryHeading.propTypes = {
  isAIQuickSearchBannerDisabled: PropTypes.bool,
  updateInputText: PropTypes.func.isRequired,
  onExampleApplied: PropTypes.func,
};

BuildQueryHeading.defaultProps = {
  onExampleApplied: () => {},
};

export default BuildQueryHeading;
